export * from './lib/+state/groups.actions';
export * from './lib/+state/groups.facade';
export * from './lib/+state/groups.reducer';
export * from './lib/+state/groups.selectors';
export * from './lib/onmat-store-group.module';
export * from './lib/service/group.service';
